import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { mediaUrl } from "@/lib/config/app";
import Link from "next/link";
import PureHtml from "@/components/custom/PureHtml";
export default function BrowseCollections(t0) {
  const $ = _c(16);
  const {
    bcols
  } = t0;
  const t1 = `browse-collections py-2 lg:py-4 ${bcols?.style}`;
  let t2;
  if ($[0] !== bcols.heading) {
    t2 = <h2 className="text-xl lg:text-2xl">{bcols.heading}</h2>;
    $[0] = bcols.heading;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = bcols?.subtext;
  let t4;
  if ($[2] !== t3) {
    t4 = <PureHtml html={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== bcols.scats || $[5] !== bcols.style) {
    t5 = bcols?.scats.length > 0 && bcols?.scats.map((scat, index) => {
      const imageAlt = scat?.image_alt || scat?.cat_name || "Collections";
      return <Link href={`/collections/${scat.cat_slug}`} key={index} className="collection-link">{bcols?.style === undefined && <div className="relative shadow" style={{
          aspectRatio: "5/2"
        }}><Image src={`${mediaUrl}${scat?.image_url || "noimage.png"}`} alt={imageAlt} fill={true} sizes="(max-width: 768px) 100vw, 33vw" className="rounded object-cover" quality={70} /><div className="fcathead">{scat.cat_name}</div></div>}{bcols?.style === "style1" && <div className="relative shadow" style={{
          aspectRatio: "5/2"
        }}><Image src={`${mediaUrl}${scat?.image_url || "noimage.png"}`} alt={imageAlt} sizes="(max-width: 768px) 100vw, 33vw" fill={true} className="rounded object-cover" quality={70} /><div className="fcathead">{scat.cat_name}</div></div>}{bcols?.style === "style1b" && <div className="relative shadow" style={{
          aspectRatio: "5/2"
        }}><Image src={`${mediaUrl}${scat?.image_url || "noimage.png"}`} alt={imageAlt} fill={true} sizes="(max-width: 768px) 100vw, 33vw" className="rounded object-cover" quality={70} /><div className="absolute top-2 lg:top-4 left-2 lg:left-4"><div className="text-base lg:text-xl font-heading mb-1 lg:mb-2 text-white drop-shadow-black drop-shadow-xs">{scat?.cat_name || "Collection"}</div><div className="text-xs lg:text-sm font-heading inline-block py-0.5 px-3 rounded bg-secondary text-white shadow">Shop Now</div></div></div>}{bcols?.style === "style2" && <div className="relative shadow" style={{
          aspectRatio: "5/2"
        }}><Image src={`${mediaUrl}${scat?.image_url || "noimage.png"}`} alt={imageAlt} fill={true} sizes="(max-width: 768px) 100vw, 33vw" className="rounded object-cover" quality={70} /></div>}{bcols?.style === "style3" && <div className="relative shadow" style={{
          aspectRatio: "5/2"
        }}><Image src={`${mediaUrl}${scat?.image_url || "noimage.png"}`} alt={imageAlt} fill={true} sizes="(max-width: 768px) 100vw, 33vw" className="rounded object-cover" quality={70} /></div>}{bcols?.style === "style4" && <div><div className="relative shadow" style={{
            aspectRatio: "5/2"
          }}><Image src={`${mediaUrl}${scat?.image_url || "noimage.png"}`} alt={imageAlt} fill={true} sizes="(max-width: 768px) 100vw, 33vw" className="rounded object-cover" quality={70} /></div><div className="relative mt-2"><div className="text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize">{scat?.cat_name || "Collection"}</div></div></div>}{bcols?.style === "style5" && <div className="relative shadow" style={{
          aspectRatio: "5/2"
        }}><Image src={`${mediaUrl}${scat?.image_url || "noimage.png"}`} alt={imageAlt} fill={true} sizes="(max-width: 768px) 100vw, 33vw" className="rounded object-cover" quality={70} /><div className="absolute top-2 lg:top-4 left-2 lg:left-1/20 bg-white/90 px-2 rounded shadow-lg w-9/10"><div className="text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize">{scat?.cat_name || "Collection"}</div></div></div>}{bcols?.style === "style5b" && <div className="relative shadow" style={{
          aspectRatio: "5/2"
        }}><Image src={`${mediaUrl}${scat?.image_url || "noimage.png"}`} alt={imageAlt} fill={true} sizes="(max-width: 768px) 100vw, 33vw" className="rounded object-cover" quality={70} /><div className="absolute bottom-2 lg:bottom-4 left-2 lg:left-1/20 bg-white/90 px-2 rounded shadow-lg w-9/10"><div className="text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize">{scat?.cat_name || "Collection"}</div></div></div>}{bcols?.style === "style6" && <div><div className="relative shadow overflow-hidden rounded-tl-3xl rounded-br-3xl" style={{
            aspectRatio: "5/2"
          }}><Image src={`${mediaUrl}${scat?.image_url || "noimage.png"}`} alt={imageAlt} fill={true} sizes="(max-width: 768px) 100vw, 33vw" className="rounded-tl-3xl rounded-br-3xl object-cover" quality={70} /></div><div className="relative mt-2"><div className="text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize">{scat?.cat_name || "Collection"}</div></div></div>}</Link>;
    });
    $[4] = bcols.scats;
    $[5] = bcols.style;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-3">{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t4 || $[11] !== t6) {
    t7 = <div className="max-w-7xl mx-auto px-2">{t2}{t4}{t6}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t7) {
    t8 = <section className={t1}>{t7}</section>;
    $[13] = t1;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}